import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import CommonImage from '@components/CommonImage';
import { toastError } from '@components/Toast';

import { setTag, showTwoDecimalNumber } from '@utils/Util';

const DesignCard = ({
	productList,
	productIdsOnCollection,
	addToCollection,
	onScrollList,
	emptyMessage,
	requestFrom
}) => {
	const isShowFabricStatus = (product) => {
		if (product?.isSet) {
			return product?.setMemberProducts.forEach((member) => {
				if (!member.fabricDetails && !member.fabricName) {
					return true;
				}
			});
		} else {
			if (!product.fabricDetails && !product.fabricName) {
				return true;
			}
		}
	};

	return (
		<div className="style-sidebar scroll-parent scroll-y-label" onScroll={(e) => onScrollList(e)}>
			<div className="design-list-container sidebar-design-container">
				<div className="design-list-row">
					{productList?.length === 0 ? (
						<div className="empty-state text-center w-100">
							{emptyMessage && <p className="medium-16 gray_dark_02">{emptyMessage}</p>}
							{!emptyMessage && <p className="medium-16 gray_dark_02">No design found</p>}
							{!emptyMessage && (
								<p className="regular-14 gray_dark_02 mt-1">
									Select style & copy to this collection
								</p>
							)}
						</div>
					) : (
						productList.map((design) => (
							<div
								className={`design-single-item ${
									productIdsOnCollection.includes(design.id) ? 'added' : ''
								}`}
								key={design.id}
								onClick={() => {
									if (!isShowFabricStatus(design)) {
										addToCollection(design);
									} else {
										toastError('Please add body fabric for place order.');
									}
								}}
							>
								<div className="single-design-card" key={design.id}>
									<div
										className={`card-top ${
											requestFrom === 'ORDER' ? 'add-to-order' : ''
										}`}
									>
										{design.isSet ? (
											design.designDocuments &&
											design.designDocuments
												.slice(0, 2)
												.map((image) => (
													<img
														src={image?.docUrl}
														key={image?.id}
														className="card-image"
														style={{ height: '50%', width: '100%' }}
													/>
												))
										) : (
											<img
												src={design?.designDocuments[0]?.docUrl}
												className="card-image"
											/>
										)}
										{isShowFabricStatus(design) && (
											<Tooltip
												title="Please add body fabric for place order."
												placement="top"
												arrow
											>
												<CommonImage
													className="info-icon ml-1"
													src={`/images/icons/delivery-status-icon.svg`}
													alt=""
													width={24}
													height={24}
												/>
											</Tooltip>
										)}
										<div className="price-and-status">
											{design?.isSet && setTag()}

											{design?.baseAdminPrice && (
												<p className="regular-12 gray_dark_01 price weight-500">
													${showTwoDecimalNumber(design?.baseAdminPrice)}
												</p>
											)}

											<ul className="common-list-component addedBy-status">
												<li>
													<span className="designer-name text-uppercase">
														{design.addedByName}
													</span>
												</li>
												{!design?.isSet && (
													<li className="status">
														<span
															className={`${
																design.availabilityStatus === 'DEVELOPMENT'
																	? 'development'
																	: design.availabilityStatus === 'INITIAL'
																		? 'initial'
																		: design.availabilityStatus === 'SOLD'
																			? 'red'
																			: design.availabilityStatus ===
																				  'COMPLETE'
																				? 'complete'
																				: ''
															}`}
														>
															{design.availabilityStatus}
														</span>
													</li>
												)}
											</ul>
										</div>
									</div>
									<div className="card-content">
										<div className="card-info">
											<p className="mb-0 regular-12 gray_dark-_02">
												{design.referenceNumber}
											</p>
										</div>
									</div>
								</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
	);
};

export default DesignCard;
